import React from 'react';

const AboutUs = () => {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-center text-royal-blue mb-6">About Us</h1>
      <p className="text-lg text-gray-700 mb-8">
        Established in 2024, <strong>Ekul Consulting Agency Limited</strong> has grown to become a trusted name in human resource solutions across East Africa. Headquartered in Mombasa, Kenya, we specialize in connecting talented professionals with organizations in diverse industries.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left Column */}
        <div>
          <h2 className="text-2xl font-bold text-royal-blue mb-4">Our Story</h2>
          <p className="text-gray-700 mb-6">
            Founded by a team of HR experts, Ekul Consulting was born out of a desire to bridge the gap between employers and job seekers.
          </p>
          <h2 className="text-2xl font-bold text-royal-blue mb-4">Meet Our Team</h2>
          <p className="text-gray-700 mb-6">
            Our team consists of experienced HR professionals, industry experts, and technology enthusiasts.
          </p>
        </div>

        {/* Right Column */}
        <div>
          <img src="https://via.placeholder.com/400x300?text=Team Photo" alt="Team " className="w-full h-64 object-cover mb-4" />
          <h2 className="text-2xl font-bold text-royal-blue mb-4">Core Values</h2>
          <ul className="list-disc pl-6 text-gray-700">
            <li><strong>Integrity:</strong> We uphold transparency and honesty in all our dealings.</li>
            <li><strong>Innovation:</strong> We embrace creative solutions to meet evolving needs.</li>
            <li><strong>Excellence:</strong> We strive for the highest standards in service delivery.</li>
            <li><strong>Collaboration:</strong> We work together to achieve shared goals.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;